<template>
<section id="Carousel" class="CarouselBlock" @mouseenter="on_top_enter" @mouseleave="on_top_leave">
  <swiper :options="swiperOption" ref="mySwiper">
    <swiper-slide class="swiper-slide">
      <img :src="'../../static/img/banner1.png'"/>
    </swiper-slide>
     <swiper-slide class="swiper-slide">
      <img :src="'../../static/img/banner2.png'" @click="clickMethod('cooperation')"/>
    </swiper-slide>
    <swiper-slide class="swiper-slide">
      <img :src="'../../static/img/banner3.png'" @click="clickMethod('advertisement')"/>
    </swiper-slide>
    <!-- 分页器 -->
    <div class="swiper-pagination"  slot="pagination"></div>
      <!-- 左右箭头 -->
    <!-- <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div> -->
  </swiper>
</section>
</template>

<script>
import 'swiper/css/swiper.css'
export default {
  data () {
    return {
      carouselArr: [],
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        autoplayDisableOnInteraction: false,
        paginationClickable: true,
        autoplay: true,
        // autoplay: {
        //   delay: 4000,
        //   disableOnInteraction: false
        // },
        loop: false
      },
      screenWidth: document.documentElement.clientWidth
    }
  },
  watch: {
    'screenWidth': (val) => {
    }
  },
  computed: {
    mySwiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted () {
    window.onresize = this.changeBanner
  },
  created () {
    this.changeBanner()
  },
  methods: {
    clickMethod (option) {
      this.$emit('clickMethod', option)
    },
    on_top_enter () {
      this.mySwiper.autoplay.stop()
    },
    on_top_leave () {
      this.mySwiper.autoplay.start()
    },
    changeBanner () {
      let clientWidth = document.documentElement.clientWidth
      this.screenWidth = clientWidth
    }
  }
}
</script>
<style lang="less" scoped>
  /deep/.swiper-pagination-bullet {
    border-radius: 50% !important;
    background: rgba(255, 255, 255, 0.5);
    border: none;
  }
  /deep/.swiper-pagination-bullet-active {
    background-color: white;
  }
  /deep/.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
    margin-bottom: -20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Swiper.vue